import { Text } from '@mantine/core';
import cx from 'clsx';
import { Draggable } from '@hello-pangea/dnd';
import { IconGripVertical } from '@tabler/icons-react';
import classes from './dnd-card.module.css';

interface DndListHandleProps {
  cardDetails: {
    key: string;
    index: number;
    text: string;
    subText?: string;
    columnIndex?: number;
  };
}

function DndCard({ cardDetails }: DndListHandleProps) {
  const isMovedFromPickList = cardDetails.columnIndex && cardDetails.columnIndex !== 0;

  return (
    <Draggable key={cardDetails.key} index={cardDetails.index} draggableId={cardDetails.key}>
      {(provided, snapshot) => (
        <div
          className={cx(classes.item, {
            [classes.itemDragging]: snapshot.isDragging,
            [classes.itemMoved]: isMovedFromPickList,
          })}
          ref={provided.innerRef}
          {...provided.dragHandleProps}
          {...provided.draggableProps}
        >
          <div {...provided.dragHandleProps} className={classes.dragHandle}>
            <IconGripVertical size="2.0rem" stroke={1.5} />
            {cardDetails.index !== undefined && cardDetails.columnIndex !== 0 && (
              <Text fz="xl" fw={600}>
                {cardDetails.index + 1}
              </Text>
            )}
          </div>
          <div {...provided.dragHandleProps}>
            <Text>{cardDetails.text}</Text>
            <Text color="dimmed" size="sm">
              {cardDetails.subText}
            </Text>
          </div>
        </div>
      )}
    </Draggable>
  );
}

export default DndCard;
